import { render } from "./UsersRecipes.vue?vue&type=template&id=0083de15"
import script from "./UsersRecipes.vue?vue&type=script&lang=js"
export * from "./UsersRecipes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__